import React, {useState} from 'react';
import FileService from "../../API/orders/orders/organization/FileService";
import UploadFilesForm from "./UploadFilesForm";

const UploadOrderEstimateFileForm = ({label, year, orderId, change, setChange, handleModalAlert}) => {

    const [selectedFile, setSelectedFile] = useState(null);

    const handleUpload = async (event) => {
        event.preventDefault();
        FileService.uploadOrderEstimateFile(year, orderId, selectedFile[0])
            .then(function () {
                setChange(!change)
                handleModalAlert("Смета загружена", 'success')
            })
            .catch(function (error) {
                handleModalAlert(error);
            })
            .finally(function () {
                event.target.reset();
                setSelectedFile(null)
            })
    }

    return (
        <div>
            <UploadFilesForm
                uploadData={{id: 1, helpText: "Импорт сметы из файла сметы базис-мебельщика *.xls"}}
                handleUpload={handleUpload}
                selectedFiles={selectedFile}
                setSelectedFiles={setSelectedFile}
                label={'Загрузить смету проекта'}
                multiple={false}
            />
        </div>
    );
};

export default UploadOrderEstimateFileForm;